export const COMMENT_THREAD_PAGINATION_LIMIT = 10;
